import "@videojs/core";
import { createContext, useContext } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/ui/poster/context.tsx
const PosterContext = createContext(null);
function PosterProvider({ value, children }) {
	return /* @__PURE__ */ jsx(PosterContext.Provider, {
		value,
		children
	});
}
function usePosterContext() {
	const ctx = useContext(PosterContext);
	if (!ctx) throw new Error("Poster compound components must be used within a Poster.Root");
	return ctx;
}
//#endregion
export { PosterProvider, usePosterContext };

//# sourceMappingURL=context.js.map